<template>
  <div class="row">
    <div class="col-md-3">
      <base-button class="clock-button" disabled block :type="status">
        Status
      </base-button>
    </div>
    <div class="col-md-3">
      <base-button class="clock-button" v-if="!ticket['is_done']" :disabled="ticket['ticket_id'] == 0" simple block type="success" @click="update('Submit')">
        Submit
      </base-button>
      <base-button class="clock-button" v-else disabled simple block type="success">
        Submit
      </base-button>
    </div>
    <div class="col-md-3">
      <base-button class="clock-button" v-if="isAuthor && ticket['is_done'] && !ticket['is_confirm']  && ticket['ticket_id'] != 0" simple block type="info" @click="update('Confirm')">
        Confirm
      </base-button>
      <base-button class="clock-button" v-else simple disabled block type="info" @click="update('Confirm')">
        Confirm
      </base-button>
    </div>
    <div class="col-md-3">
      <base-button class="clock-button" v-if="isAuthor && ticket['is_done'] && ticket['ticket_id'] != 0" simple block type="danger" @click="update('Decline')">
        Decline
      </base-button>
      <base-button class="clock-button" v-else simple disabled block type="danger">
        Decline
      </base-button>
    </div>
  </div>
</template>

<script>
    export default {
      name: "ButtonsBlock",
      props: ['ticket', 'status', 'isAuthor'],
      methods:{
        update(command){
          const data = {};
          let action = "";
          data['ticket_id'] = this.ticket['ticket_id'];
          if (command === "Submit"){
            action = 'completed';
            data['is_done'] = "1";
            data['is_read_from'] = "0";
            this.ticket['is_done'] = true;
          }
          if (command === "Confirm"){
            action = 'confirmed';
            data['is_confirm'] = "1";
            this.ticket['is_confirm'] = true;
          }
          if (command === "Decline"){
            action = 'declined';
            data['is_done'] = "0";
            data['is_confirm'] = "0";
            data['is_read_to'] = "0";
            this.ticket['is_done'] = false;
            this.ticket['is_confirm'] = false;
          }
          this.$emit("update", data, action);
        },
      }
    }
</script>

<style scoped>

</style>
